import { logger } from "./loggingService";
import bearerAxios from "../helpers/bearerAxios";
const baseURL = import.meta.env.VITE_BASE_URL!;

const checkFileExist = (filename: string) => {
    return bearerAxios
        .get(baseURL + import.meta.env.VITE_AZURE_CRUD_DOWNLOAD_FILE + filename)
        .then((response) => {
            if(response.status === 200 && response.data){
                return true;
            }
            return false;
        })
        .catch((e) => {
            if(e?.response?.status === 400 && e?.response?.data?.Message === "Unable to find the specified file.-Please Contact Administrator."){
                return false;
            }
            logger.error(e);
            return false;
        });
}

const getFile = (filename: string) => {
    return bearerAxios
        .get(baseURL + import.meta.env.VITE_AZURE_CRUD_DOWNLOAD_FILE + filename,{
            responseType: 'blob'
        })
        .then((response) => {
            return response.data;
        })
        .catch((e) => {
            if (e?.response?.status === 400) {
                return null;
            }
            logger.error(e);
            return null;
        });
};

const deleteFile = (fileName: string) => {
    try {
        return bearerAxios
            .get(baseURL + import.meta.env.VITE_AZURE_CRUD_DELETE_FILE + fileName)
            .then((response) => {
                return response.data;
            });
    } catch (e) {
        console.log(e);
    }
};

const uploadFile = (data: any) => {
    const formData = new FormData();

    formData.append('asset', data);

    try {
        return bearerAxios
            .post(baseURL + import.meta.env.VITE_AZURE_CRUD_INSERT_FILE, formData)
            .then((response) => response.data);
    } catch (e) {
        logger.error(e);
    }
};

const azureBLOBStorageService = {
    uploadFile,
    getFile,
    deleteFile,
    checkFileExist
};

export default azureBLOBStorageService;
